/*
 * Public API Surface of stam
 */

export * from './lib/stam.service';
export * from './lib/stam.component';
export * from './lib/stam.module';
